import {useEffect, useState} from 'react';
import {MEDIA_QUERIES} from '@/styles';

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    setMatches(mediaQuery.matches);

    const handler = (event: MediaQueryListEvent) => setMatches(event.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handler);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handler);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return matches;
};

export const useBreakpoints = () => {
  const isMobile = useMediaQuery(
    MEDIA_QUERIES.mobile.replace('@media screen and ', '')
  );
  const isTablet = useMediaQuery(
    MEDIA_QUERIES.tablet.replace('@media screen and ', '')
  );
  const isDesktop = useMediaQuery(
    MEDIA_QUERIES.desktop.replace('@media screen and ', '')
  );

  return {
    isDesktop,
    isMobile,
    isTablet,
    isTabletOnly: isTablet && !isMobile,
    isExcludedMobile: !isMobile,
  };
};
